// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from './types.tsx';

export const actions = {
	setIsModalOpenViaAddView:
		(isOpen: boolean): Action<State> =>
		({ setState }) => {
			setState({ isModalOpenViaAddView: isOpen });
		},
};
